var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav-tabs-wrapper nav-tabs-multiple coupled bb-0 card",
      staticStyle: { overflow: "visible !important" },
    },
    [
      _c(
        "li",
        { staticClass: "nav nav-tabs scroll-container" },
        _vm._l(_vm.pages, function (menuPage) {
          return _c(
            "ul",
            {
              key: menuPage.key,
              staticClass: "nav-item secondary",
              class: { "text-secondary bold": _vm.page === menuPage.key },
              attrs: { id: menuPage.key },
              on: {
                click: function ($event) {
                  return _vm.handlePageChange(menuPage.key)
                },
              },
            },
            [
              _c(
                "a",
                { staticClass: "nav-link grey-text text-darken-3 clickable" },
                [_vm._v(_vm._s(menuPage.label))]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }